import {useState} from "react"
import { FaLinkedin } from 'react-icons/fa';
import { FaBehanceSquare } from 'react-icons/fa';
import { FaGithubSquare } from 'react-icons/fa';
import { RiHomeSmile2Fill } from 'react-icons/ri';
import { TbInfoSquareRoundedFilled } from 'react-icons/tb';
import { MdFolderCopy } from 'react-icons/md';
import { MdPermContactCalendar } from 'react-icons/md';
import { GiSkills } from 'react-icons/gi';
import { FaAward } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logo from '../../../assets/logo-01.svg';

const Sidebar = () => {

   const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <div>
          <div class="lg:hidden">
            <div className="flex items-center justify-between bg-gray-800">
             <Link to="/" className="lg:hidden px-2">
             <img className="w-24 h-24" src={logo} alt="" />   
             </Link>
             <button
            aria-label="Open Menu"
            title="Open Menu"
            class="px-2 transition duration-200 rounded focus:outline-none focus:shadow-outline hover:bg-deep-purple-50 focus:bg-deep-purple-50"
            onClick={() => setIsMenuOpen(true)}
          >
            <svg class="w-6 text-gray-50" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
              />
              <path
                fill="currentColor"
                d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
              />
              <path
                fill="currentColor"
                d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
              />
            </svg>
          </button>
            </div>
          
          {isMenuOpen && (
            <div class="absolute top-0 right-0 w-50">
              <div class="px-5 py-3 bg-gray-700 border rounded shadow-sm">
                <div class="flex items-center justify-between mb-4">
                  <div> 
                    <Link to="/" className="lg:hidden px-2">
                    <img className="w-24 h-24" src={logo} alt="" />   
                    </Link>
                  </div>
                  <div>
                    <button
                      aria-label="Close Menu"
                      title="Close Menu"
                      class="p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-gray-50 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      <svg class="w-5 text-gray-50" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <nav>
                  <ul className="space-y-4 font-medium">
                     <li> 
                        <Link to="/" className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100">
                           <RiHomeSmile2Fill className="flex-shrink-0 w-6 h-6 text-[#976DB2] transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"></RiHomeSmile2Fill>
                           <span className="flex-1 ml-5 whitespace-nowrap text-left text-gray-50 hover:text-[#976db2]">Home</span>
                        </Link>
                     </li>
                     <li> 
                        <Link to="/aboutme" className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100">
                           <TbInfoSquareRoundedFilled className="flex-shrink-0 w-6 h-6 text-[#976DB2] transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"></TbInfoSquareRoundedFilled>
                           <span className="flex-1 ml-5 whitespace-nowrap text-left text-gray-50 hover:text-[#976db2]">About</span>
                        </Link>
                     </li>
                     <li>
                        <Link to='/skill' className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100">
                           <GiSkills className="flex-shrink-0 w-6 h-6 text-[#976DB2] transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"></GiSkills>
                           <span className="flex-1 ml-5 whitespace-nowrap text-left text-gray-50 hover:text-[#976db2]">Skill</span>
                        </Link>
                     </li>
                     <li>
                        <Link to='/portfolio' className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100">
                           <MdFolderCopy className="flex-shrink-0 w-6 h-6 text-[#976DB2] transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"></MdFolderCopy>
                           <span className="flex-1 ml-5 whitespace-nowrap text-left text-gray-50 hover:text-[#976db2]">Portfolio</span>
                        </Link>
                     </li>
                     {/* <li>
                        <Link to='/cv' className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100">
                           <FaStickyNote className="flex-shrink-0 w-6 h-6 text-[#976DB2] transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"></FaStickyNote>
                           <span className="flex-1 ml-5 whitespace-nowrap text-left text-gray-50 hover:text-[#976db2]">CV</span>
                        </Link>
                     </li> */}
                     <li>
                        <Link to='/contact' className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100">
                           <MdPermContactCalendar className="flex-shrink-0 w-6 h-6 text-[#976DB2] transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"></MdPermContactCalendar>
                           <span className="flex-1 ml-5 whitespace-nowrap text-left text-gray-50 hover:text-[#976db2]">Contact</span>
                        </Link>
                     </li>
                  </ul>
                  <div className='mt-10 flex gap-4 ml-2 justify-start font-medium text-2xl text-[#976DB2]'>
                     <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/mursona/"><FaLinkedin></FaLinkedin></a>
                     <a target="_blank" rel="noreferrer" href="https://www.behance.net/mahabubamursona"><FaBehanceSquare></FaBehanceSquare></a>
                     <a target="_blank" rel="noreferrer" href="https://github.com/mursona"><FaGithubSquare></FaGithubSquare></a>
                  </div>
                  <div className='mt-2 font-medium text-sm text-[#976DB2]'>
                  © 2023 Mursona
                  </div>
                </nav>
              </div>
            </div>
          )}
          </div>

            <aside className="fixed top-0 left-0 z-40 w-40 h-screen transition-transform -translate-x-full sm:translate-x-0" aria-label="Sidebar lg:block sm:none">
               <div className="h-full px-3 py-6 overflow-y-auto bg-gray-800 dark:bg-gray-800">
                  <Link to="/" className="flex px-2 mb-20">
                  <img className="w-30 h-30" src={logo} alt="" />   
                  </Link>

                  <ul className="space-y-2 font-medium">
                     <li> 
                        <Link to="/" className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100">
                           <RiHomeSmile2Fill className="flex-shrink-0 w-6 h-6 text-[#976DB2] transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"></RiHomeSmile2Fill>
                           <span className="flex-1 ml-5 whitespace-nowrap text-left text-gray-50 hover:text-[#976db2]">Home</span>
                        </Link>
                     </li>
                     <li> 
                        <Link to="/aboutme" className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100">
                           <TbInfoSquareRoundedFilled className="flex-shrink-0 w-6 h-6 text-[#976DB2] transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"></TbInfoSquareRoundedFilled>
                           <span className="flex-1 ml-5 whitespace-nowrap text-left text-gray-50 hover:text-[#976db2]">About</span>
                        </Link>
                     </li>
                     <li>
                        <Link to='/skill' className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100">
                           <GiSkills className="flex-shrink-0 w-6 h-6 text-[#976DB2] transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"></GiSkills>
                           <span className="flex-1 ml-5 whitespace-nowrap text-left text-gray-50 hover:text-[#976db2]">Skill</span>
                        </Link>
                     </li>
                     <li>
                        <Link to='/portfolio' className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100">
                           <MdFolderCopy className="flex-shrink-0 w-6 h-6 text-[#976DB2] transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"></MdFolderCopy>
                           <span className="flex-1 ml-5 whitespace-nowrap text-left text-gray-50 hover:text-[#976db2]">Portfolio</span>
                        </Link>
                     </li>
                     <li>
                        <Link to='/achievement' className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100">
                           <FaAward className="flex-shrink-0 w-6 h-6 text-[#976DB2] transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"></FaAward>
                           <span className="flex-1 ml-5 whitespace-nowrap text-left text-gray-50 hover:text-[#976db2]">Winning</span>
                        </Link>
                     </li>
                     <li>
                        <Link to='/contact' className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100">
                           <MdPermContactCalendar className="flex-shrink-0 w-6 h-6 text-[#976DB2] transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"></MdPermContactCalendar>
                           <span className="flex-1 ml-5 whitespace-nowrap text-left text-gray-50 hover:text-[#976db2]">Contact</span>
                        </Link>
                     </li>
                  </ul>
                  <div className='mt-36 flex gap-4 ml-4 justify-start font-medium text-2xl text-[#976DB2]'>
                     <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/mursona/"><FaLinkedin></FaLinkedin></a>
                     <a target="_blank" rel="noreferrer" href="https://www.behance.net/mahabubamursona"><FaBehanceSquare></FaBehanceSquare></a>
                     <a target="_blank" rel="noreferrer" href="https://github.com/mursona"><FaGithubSquare></FaGithubSquare></a>
                  </div>
                  <div className='mt-2 font-medium text-sm text-[#976DB2]'>
                  © 2023 Mursona
                  </div>
               </div>
            </aside>
        </div>
    );
};

export default Sidebar;